import React from 'react';

import HotelIcon from '@mui/icons-material/Hotel';
import { Box, Grid, Stack, Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import BorderedGridItem from '~/components/Common/BorderedGridItem';
import PromoItemField from '~/components/PromoV3/PromoItemField';

import useQuery from '~/hooks/useQuery';

import { getPromoProductDisplayName, sortPromoItemByCategoryAndId } from '~/services/PromoService';

import currencyFormatter from '~/utils/currencyFormatter';
import { getCurrencyCodeByRegionCode } from '~/utils/getCurrencyCodeByRegionCode';

type PromoOrderTableCellProps = {
  order: definitions['Discount Request']['order'] | null;
  meta: definitions['PromoMeta'];
};

function PromoOrderTableCell({ order, meta }: PromoOrderTableCellProps) {
  const query = useQuery();
  const isDev = !!query.get('dev');

  if (order == null || order.region == null) {
    return null;
  }

  const currencyCode = getCurrencyCodeByRegionCode(order?.region);

  return (
    <Box sx={{ width: '100%' }} title={JSON.stringify(order, null, 4)}>
      {order.items.sort(sortPromoItemByCategoryAndId).map((item, i) => (
        <Grid container key={`${item.offerId}_${i}`} spacing={1} title={`${JSON.stringify(item, null, 4)}`}>
          <BorderedGridItem noBorder={i === order.items.length - 1}>
            <Stack>
              {currencyFormatter(currencyCode, item.luxPlusPrice || item.discountableTotal)}
              {item.luxPlusPrice > 0 && (
                <Typography
                  sx={{
                    textTransform: 'uppercase',
                    display: 'inline',
                    fontSize: 14,
                    fontWeight: 300,
                    textDecoration: 'line-through',
                    marginLeft: 1,
                  }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {currencyFormatter(currencyCode, item.discountableTotal)}
                </Typography>
              )}
              <PromoItemField
                title="Product Type"
                field="productType"
                categoryBK={item.categoryBK}
                value={
                  meta && getPromoProductDisplayName(meta.promo_product_types, item.categoryBK, item.subCategoryBK)
                }
              />
              {isDev && (
                <PromoItemField title="Offer ID" field="offerId" categoryBK={item.categoryBK} value={item.offerId} />
              )}
              {isDev && (
                <PromoItemField title="Item ID" field="itemId" categoryBK={item.categoryBK} value={item.itemId} />
              )}
              {order.hasBedbankPromotion && (
                <Box title="Has Bedbank Promotion">
                  <HotelIcon />
                </Box>
              )}
            </Stack>
          </BorderedGridItem>
        </Grid>
      ))}
    </Box>
  );
}

export { PromoOrderTableCell };
